import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { userChangePasswordAction } from "../../Actions/UserAction/UserAction";

const Profile = ({ userAuth }) => {
  const [newPassword, setNewPassword] = useState("");
  const [retypePassword, setRetypePassword] = useState("");
  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.changeUserPassword.loading);
  const handlePasswordChange = (e) => {
    setNewPassword(e.target.value);
  };

  const handleRetypePasswordChange = (e) => {
    setRetypePassword(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const newErrors = {};

    if (newPassword.length < 8) {
      newErrors.newPassword =
        "New password must be at least 8 characters long.";
    }

    if (newPassword !== retypePassword) {
      newErrors.retypePassword = "New passwords do not match.";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    // Add logic to handle password change
    dispatch(userChangePasswordAction(userAuth?.id, newPassword));
    setErrors({});
  };

  return (
    <div className="max-w-md mx-auto bg-white p-8 border mt-10 border-gray-300 rounded-lg shadow-lg">
      <h1 className="text-2xl font-semibold mb-6">Profile</h1>
      
      <div className="mb-4">
        <label
          className="block text-gray-700 text-sm font-bold mb-2"
          htmlFor="username"
        >
          Username
        </label>
        <input
          className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          id="username"
          type="text"
          value={userAuth?.user_info?.en_name}
          readOnly
        />
      </div>
      <form onSubmit={handleSubmit}>
        <div className="mb-4">
          <label
            className="block text-gray-700 text-sm font-bold mb-2"
            htmlFor="newPassword"
          >
            New Password
          </label>
          <input
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            id="newPassword"
            type="password"
            value={newPassword}
            onChange={handlePasswordChange}
            placeholder="Enter new password (min 8 characters)"
          />
          {errors.newPassword && (
            <p className="text-red-500 text-xs italic">{errors.newPassword}</p>
          )}
        </div>
        <div className="mb-6">
          <label
            className="block text-gray-700 text-sm font-bold mb-2"
            htmlFor="retypePassword"
          >
            Retype New Password
          </label>
          <input
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            id="retypePassword"
            type="password"
            value={retypePassword}
            onChange={handleRetypePasswordChange}
            placeholder="Retype new password"
          />
          {errors.retypePassword && (
            <p className="text-red-500 text-xs italic">
              {errors.retypePassword}
            </p>
          )}
        </div>
        {loading ? (
          <button
            type="button"
            disabled
            class="py-2 opacity-65 cursor-not-allowed px-4 flex justify-center items-center  bg-indigo-600 hover:bg-indigo-700 focus:ring-blue-500 focus:ring-offset-blue-200 text-white w-full transition ease-in duration-200 text-center text-base font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2  rounded-lg max-w-md"
          >
            <svg
              width="20"
              height="20"
              fill="currentColor"
              class="mr-2 animate-spin"
              viewBox="0 0 1792 1792"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M526 1394q0 53-37.5 90.5t-90.5 37.5q-52 0-90-38t-38-90q0-53 37.5-90.5t90.5-37.5 90.5 37.5 37.5 90.5zm498 206q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zm-704-704q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zm1202 498q0 52-38 90t-90 38q-53 0-90.5-37.5t-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zm-964-996q0 66-47 113t-113 47-113-47-47-113 47-113 113-47 113 47 47 113zm1170 498q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zm-640-704q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zm530 206q0 93-66 158.5t-158 65.5q-93 0-158.5-65.5t-65.5-158.5q0-92 65.5-158t158.5-66q92 0 158 66t66 158z"></path>
            </svg>
            Changing
          </button>
        ) : (
          <div className="flex w-full items-center justify-between">
            <button
              className="bg-indigo-600 duration-300 w-full hover:bg-indigo-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
              type="submit"
            >
              Change Password
            </button>
          </div>
        )}
      </form>
    </div>
  );
};

export default Profile;
